import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink, userSearchData, selectChooseBranch, priceDistributionRequestData, priceDistributionResponseData } from '../../../../Actions/AllAction';
import { setToken, setUserCredentials } from '../../../../GlobalModules/Login/Actions/LoginAction';
import { withNamespaces } from 'react-i18next';
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary';
import CommonDateTimePicker from '../../../../Utility/Components/CommonDateTimePicker';
import AutosuggestComponent from '../../../../Utility/Components/AutosuggestComponent';
import TextEditor from '../Components/TextEditor';
import Utility from '../../../../Utility/Utility';
import moment from 'moment';
import CustomInput from '../../../../Utility/Components/CustomInput';
import TourPriceDetails from './TourPriceDetails';
// import CreateQuoationModalContent from '../../TemplateQuotation/Components/CreateQuoationModalContent';
import ModalGlobal from '../../../../Utility/Components/ModalGlobal';
import { forEach } from 'lodash';
import PaymentModeModalContent from './PaymentModeModalContent';
import { paymentPriceDistribution, getGSTdetails, signupCustomer, createDmcLead, createDmcNote } from '../Controller/HomeController';
// import QuotationConvertBookingNumber from '../../Quotation/Components/QuotationConvertBookingNumber';
import ValidateUtility from '../../../../Utility/ValidateUtility';
import parsePhoneNumber from 'libphonenumber-js'
import PhoneNumberWithCountryCode from '../../../../Utility/Components/PhoneNumberWithCountryCode';
import { Modal, Container, Alert } from 'react-bootstrap';
import ConfirmationAlert from '../../../../Utility/Components/ConfirmationAlert';
import Button from 'react-bootstrap/Button';
import EventEmitter from '../../../../Utility/EventEmitter';
import { Routes, Route, Switch, useHistory } from "react-router-dom";
import * as LoginController from '../../../../GlobalModules/Login/Controller/LoginController';
import LoginUtility from '../../../../GlobalModules/Login/Utility/LoginUtility'
import PersonDetailsModalContent from '../Components/PersonDetailsModalContent'


function TourBooking(props) {
    const { selectedTour } = props;
    const history = useHistory();
    const [bookTourId, setBookTourId] = useState(null);
    const [selectedTourData, setSelectedTourData] = useState(selectedTour);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [startDateError, setStartDateError] = useState('');
    const [endDateError, setEndDateError] = useState('');
    // const [numAdults, setNumAdults] = useState(1);
    const [numAdults, setNumAdults] = useState(() => {
        const min = props.minimumGuestCount > 0 ? props.minimumGuestCount : 1;
        const max = props.maximumGuestCount > 0 ? props.maximumGuestCount : Infinity;
        return Math.min(Math.max(min, 1), max);
    });
    const [numChildren, setNumChildren] = useState(0);
    const [childrenAges, setChildrenAges] = useState([]);
    const [childrenAgesError, setChildrenAgesError] = useState([]);
    const childAgeinputRef = useRef(null);
    const [childrenAgeList, setChildrenAgeList] = useState([]);
    const [content, setContent] = useState(selectedTourData.content);
    const [screenView, setScreenView] = useState("2");
    const [tourBookingPrice, setTourBookingPrice] = useState({});
    const [customerModalFlag, setCustomerModalFlag] = useState(false);
    const [zoominzoomoutflag, setZoominzoomoutflag] = useState("");
    const [paymentModalFlag, setPaymentModalFlag] = useState(false);
    const [bookingDetailsDatasetWithoutPayment, setBookingDetailsDatasetWithoutPayment] = useState(null);
    const [currencyName, setCurrencyName] = useState(props.defaultBranch.currency || "INR");
    const [bookingNumberModalFlag, setBookingNumberModalFlag] = useState(false);
    const [bookingNumberObj, setBookingNumberObj] = useState({});
    const [gstPercentage, setGSTPercentage] = useState(props.gstPercentage);
    const [sacCodeId, setSacCodeId] = useState(props.sacCodeId);
    const [paymentDetailsDataSet, setPaymentDetailsDataSet] = useState({
        is_igst_enable: false,
        no_tax: false,
    });

    const [formData, setFormData] = useState({
        "name": "", "last_name": "", "phone_number": "", "email": [{ 'email': "" }], "customer_gstin_no": "",
        "company_name": "", "company_address": ""
    });
    const [formDataError, setFormDataError] = useState({ "name": "", "last_name": "", "phone_number": "", "email": [{ 'email': "" }], "customer_gstin_no": "", "company_name": "", "company_address": "" });
    const [notes, setNotes] = useState("");
    const [notesError, setNotesError] = useState("");
    const [phoneNumberCountryCode, setPhoneNumberCountryCode] = useState("in");
    const [phoneNumberDialCode, setPhoneNumberDialCode] = useState("91");
    const [selectedCustomer, setSelectedCustomer] = useState({});
    const [selectedCountryCode, setSelectedCountryCode] = useState("in");
    const emailInputRef = useRef(null);
    const [createNewPassword, setCreateNewPassword] = useState("");
    const [forcePasswordChange, setForcePasswordChange] = useState(false);
    const [veryfiFlag, setveryfiFlag] = useState(false);
    const [bookingCancellationModalFlag, setBookingCancellationModalFlag] = useState(false);
    const [password, setPassword] = useState("");
    const [retypePassword, setRetypePassword] = useState("");
    const [veryfiCode, setveryfiCode] = useState("");
    const [codeError, setcodeError] = useState("");
    const [updated_passwordError, setupdated_passwordError] = useState("");
    const [updated_comfirm_passwordError, setupdated_comfirm_passwordError] = useState("");
    //change pass
    const [changePasswordFlag, setChangePasswordFlag] = useState(false);
    const [emailPassword, setEmailPassword] = useState("");
    const [allGuestDetailsData, setAllGuestDetailsData] = useState([]);

    const [alertContainer, setAlertContainer] = useState(false);
    const [isMobileView, setIsMobileView] = useState(false);

    useEffect(() => {
        if (childrenAges.length > 2 && childAgeinputRef.current) {
            childAgeinputRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [childrenAges]);

    useEffect(() => {
        // console.log("selectedTourData-----", selectedTourData);
    }, [selectedTourData])

    useEffect(() => {
        setIsMobileView(window.innerWidth < 768)
    })


    const getNightsFromDuration = () => {
        if (selectedTourData?.duration) {
            const match = selectedTourData.duration.match(/^(\d+)\s+Nights/i);
            return match ? parseInt(match[1], 10) : 0;
        }
        return 0;
    };

    const handelChangeDate = (date, field) => {
        if (field === 'start_date') {
            const days = selectedTourData?.duration_days ? Number(selectedTourData.duration_days) - 1 : getNightsFromDuration();
            setStartDate(date);

            if (days >= 0) {
                const calculatedEndDate = new Date(date.getTime() + days * 24 * 60 * 60 * 1000);
                setEndDate(calculatedEndDate);
            } else {
                setEndDate(null);
            }

            setStartDateError('');
            setEndDateError('');
        }
        if (field === 'end_date') {
            setEndDate(date);
            setEndDateError('');
        }
    };

    const incNumAdults = () => {
        setNumAdults((prev) => {
            const max = props.maximumGuestCount > 0 ? props.maximumGuestCount : Infinity;
            return prev < max ? prev + 1 : prev;
        });
    };

    const decNumAdults = () => {
        setNumAdults((prev) => {
            const min = props.minimumGuestCount > 0 ? props.minimumGuestCount : 1;
            return prev > min ? prev - 1 : prev;
        });
    };

    useEffect(() => {
        const min = props.minimumGuestCount > 0 ? props.minimumGuestCount : 1;
        const max = props.maximumGuestCount > 0 ? props.maximumGuestCount : Infinity;
        setNumAdults((prev) => {
            if (prev < min) return min;
            if (prev > max) return max;
            return prev;
        });
    }, [props.minimumGuestCount, props.maximumGuestCount]);

    const incNumChildren = () => {
        setNumChildren((prev) => prev + 1);
    };

    const decNumChildren = () => {
        setNumChildren((prev) => (prev > 0 ? prev - 1 : 0));
    };

    const validConfirmBookingModalFn = () => {
        let tempFormDataError = { ...formDataError }
        let isValid = true;
        if (!startDate) {
            setStartDateError('Please select start date');
            Utility.toastNotifications("Please select start date", "Error", "error");
            isValid = false;
        }
        if (selectedTourData.price_for_adult == "" || selectedTourData.price_for_adult <= 0) {
            Utility.toastNotifications("Please enter a valid number for the adult price", "Error", "error");
            isValid = false;
        }
        if (tourBookingPrice.childCount > 0 && (selectedTourData.price_for_children == "" || selectedTourData.price_for_children <= 0)) {
            Utility.toastNotifications("Please enter a valid number for the children price", "Error", "error");
            isValid = false;
        }

        forEach(childrenAges, (child, index) => {
            if (!child.age) {
                Utility.toastNotifications("Please select children age", "Error", "error")
                isValid = false;
                return;
            }
        });

        if (props.isGuestFlag) {
            if ((formData.name).trim() == "") {
                isValid = false;
                tempFormDataError['name'] = "Required Field"
            }

            if ((formData.last_name).trim() == "") {
                isValid = false;
                tempFormDataError['last_name'] = "Required Field"
            }

            formData.email.forEach((emailObj, index) => {
                const email = emailObj.email.trim();

                if (index == 0) {
                    if (tempFormDataError['email'][0]['email'] == 'User already exits in management role') {
                        isValid = false;
                    }
                }
                if (email === "") {
                    tempFormDataError['email'][index]['email'] = "";
                } else if (!isValidEmail(email)) {
                    isValid = false;
                    tempFormDataError['email'][index]['email'] = "Enter valid email";
                }
            });

            if (formData.phone_number == "" || formData.phone_number == null) {
                tempFormDataError['phone_number'] = "Required field"
                isValid = false
            } else {
                let modifiedString = ValidateUtility.deleteAndBefore(formData.phone_number, phoneNumberDialCode);
                let countryCodeValue = phoneNumberCountryCode.toUpperCase();
                const phoneNumber = parsePhoneNumber(modifiedString, countryCodeValue);
                if (phoneNumber && phoneNumber.isValid()) {
                    tempFormDataError['phone_number'] = ""
                } else {
                    tempFormDataError['phone_number'] = "Enter valid contact number"
                    isValid = false
                }
            }

            if (formData.customer_gstin_no != "") {
                let gstnValidate = ValidateUtility.validate_gstn_Number(formData.customer_gstin_no);
                if (!gstnValidate) {
                    isValid = false;
                    tempFormDataError['customer_gstin_no'] = "Please enter a correct GSTIN No"
                }
            }
            setFormDataError(tempFormDataError)
        }

        return isValid;
    }

    const isValidEmail = (email) => {
        const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return emailRegex.test(email);
    };

    const paymentAndBookingFn = () => {
        let valid = validConfirmBookingModalFn()
        // console.log("valid----", valid);
        if (!valid) {
            let pageBottom = document.querySelector('#page-bottom');
            pageBottom.scrollIntoView({ behavior: 'smooth' });
        }
        if (valid) {
            setBookingCancellationModalFlag(true);
        }
    }

    const skipFn = () => {
        setBookingCancellationModalFlag(false);
        if (props.closePaymentDetailsModalFn) {
            props.closePaymentDetailsModalFn();
        }
    }


    useEffect(() => {
        if (selectedTour?.is_fixed_date) {
            // console.log("selectedTour------------------",selectedTour?.start_date, selectedTour?.end_date)
            // console.log("selectedTour",moment(selectedTour?.start_date.toString()).format('DD-MM-YYYY'), moment(selectedTour?.end_date.toString()).format('DD-MM-YYYY'))
            setStartDate(new Date(selectedTour?.start_date.toString()));
            setEndDate(new Date(selectedTour?.end_date.toString()));
        }
    }, [selectedTour]);


    useEffect(() => {
        if (formData.email.length > 1) {
            if (emailInputRef.current) {
                emailInputRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [formData]);

    //email input onchange fn
    const handelChangeEmailFn = (e, field, idx) => {
        const value = e.target.value;
        const updatedFormData = { ...formData };
        const updatedFormDataError = { ...formDataError };
        if (field === 'email' && typeof idx === 'number') {
            let emailValidate = ValidateUtility.validate_email(value);
            if (emailValidate) {
                updatedFormData[field][idx].email = value;
                updatedFormDataError[field][idx].email = "";
            } else {
                updatedFormData[field][idx].email = value;
                updatedFormDataError[field][idx].email = "Enter valid email"
            }
        } else {
            updatedFormData[field] = value;
        }
        setFormData(updatedFormData);
    };

    //email remove fn
    const emailRemoveClick = (e, idx) => {
        const updatedFormData = { ...formData };
        const updatedFormDataError = { ...formDataError };

        updatedFormData.email.splice(idx, 1);
        updatedFormDataError.email.splice(idx, 1);
        setFormData(updatedFormData);
        setFormDataError(updatedFormDataError);
    };


    //email input field ui
    const emailUi = () => {
        return formData.email.map((emailObj, idx) => (
            <>
                <div key={idx} className="col-md-3">
                    <div className="payableServiceRow">
                        <div className="row">
                            <div className="col-md-12 editIconBox">
                                <ErrorBoundary title="CustomInput Error">
                                    <CustomInput
                                        parentClassName="input_field_inner"
                                        labelName="Email"
                                        errorLabel={formDataError.email[idx].email}
                                        name={`email_${idx}`}
                                        type="text"
                                        value={emailObj.email}
                                        labelPresent={true}
                                        requiredStar={false}
                                        onChange={(e) => handelChangeEmailFn(e, 'email', idx)}
                                    />
                                </ErrorBoundary>
                                <div className="deleteBoxInner">
                                    {idx > 0 && (
                                        <span onClick={(e) => { emailRemoveClick(e, idx) }} className="deleteBox" >
                                            <i className="fa fa-trash" aria-hidden="true"></i>
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        ));
    };

    //customer details field on change function
    const handelChangeCustomerFn = (e, type, dialCodeObj = {}) => {
        let tempFormData = { ...formData };
        let tempFormDataError = { ...formDataError }

        if (type == "name") {
            var expr = /^[a-zA-Z ]*$/;
            if (!expr.test(e.target.value)) {
            } else {
                if (e.target.value == "") {
                    tempFormDataError['name'] = ""
                    tempFormData["name"] = ""
                } else {
                    tempFormData["name"] = e.target.value
                    tempFormDataError['name'] = ""
                }
            }
        }
        if (type == "last_name") {
            var expr = /^[a-zA-Z ]*$/;
            if (!expr.test(e.target.value)) {
            } else {
                if (e.target.value == "") {
                    tempFormDataError['last_name'] = ""
                    tempFormData["last_name"] = ""
                } else {
                    tempFormData["last_name"] = e.target.value
                    tempFormDataError['last_name'] = ""
                }
            }
        }

        if (type == "customer_gstin_no") {
            if (e.target.value == "") {
                tempFormDataError['customer_gstin_no'] = ""
                tempFormData["customer_gstin_no"] = ""
            } else {
                let gstnValidate = ValidateUtility.validate_gstn_Number(e.target.value);
                if (gstnValidate) {
                    tempFormData["customer_gstin_no"] = e.target.value
                    tempFormDataError['customer_gstin_no'] = ""
                } else {
                    tempFormData["customer_gstin_no"] = e.target.value
                    tempFormDataError['customer_gstin_no'] = "Please enter a correct GSTIN No"
                }
            }
        }

        if (type == "company_name") {
            var expr = /^[a-zA-Z ]*$/;
            if (!expr.test(e.target.value)) {
            } else {
                if (e.target.value == "") {
                    tempFormDataError['company_name'] = ""
                    tempFormData["company_name"] = ""
                } else {
                    tempFormData["company_name"] = e.target.value
                    tempFormDataError['company_name'] = ""
                }
            }
        }

        if (type == "company_address") {
            if (e.target.value == "") {
                tempFormDataError['company_address'] = ""
                tempFormData["company_address"] = ""
            } else {
                tempFormData["company_address"] = e.target.value
                tempFormDataError['company_address'] = ""
            }
        }

        if (type == "email") {
            if (e.target.value == "") {
                tempFormDataError['email'] = ""
                tempFormData["email"] = ""
            } else {
                let emailValidate = ValidateUtility.validate_email(e.target.value);
                if (emailValidate) {
                    tempFormData["email"] = e.target.value
                    tempFormDataError['email'] = ""
                } else {
                    tempFormData["email"] = e.target.value
                    tempFormDataError['email'] = "Enter valid email"
                }
            }
        }


        if (type == "phone_number") {
            if (e.trim() !== "") {
                let modifiedString = ValidateUtility.deleteAndBefore(e, dialCodeObj.dialCode);
                let countryCodeValue = dialCodeObj.countryCode.toUpperCase();
                const phoneNumber = parsePhoneNumber(modifiedString, countryCodeValue);
                setPhoneNumberCountryCode(dialCodeObj.countryCode)
                setPhoneNumberDialCode(dialCodeObj.dialCode)
                if (phoneNumber && phoneNumber.isValid()) {
                    tempFormData["phone_number"] = e
                    tempFormDataError['phone_number'] = ""
                } else {
                    tempFormData["phone_number"] = e
                    tempFormDataError['phone_number'] = "Enter valid contact number"
                }
            } else {
                tempFormData["phone_number"] = "";
                tempFormDataError['phone_number'] = "Required field";
            }
        }

        if (type == "customer") {
            setSelectedCustomer(e)
            tempFormData['name'] = e.name;
            tempFormData['last_name'] = e.last_name;
            tempFormData["email"] = [{ 'email': e.email }];
            tempFormData["phone_number"] = e.phone_number;
            tempFormData["customer_gstin_no"] = e.customer_gstin_no;
            tempFormData["company_name"] = e.company_name;
            tempFormData["company_address"] = e.company_address;
            tempFormDataError['name'] = ""
            tempFormDataError['last_name'] = ""
            tempFormDataError["email"] = [{ 'email': "" }]
            tempFormDataError["phone_number"] = ""
            tempFormDataError["customer_gstin_no"] = ""
            tempFormDataError["company_name"] = ""
            tempFormDataError["company_address"] = ""
        }

        if (type == "notes") {
            setNotes(e.target.value);
            setNotesError("");
        }

        setFormData(tempFormData)
        setFormDataError(tempFormDataError)
    }

    const submitDmcLead = () => {
        const customerEmail = typeof formData.email === 'string' ? formData.email : (formData.email?.[0]?.email || "");
        const customerPhone = formData.phone_number ? (formData.phone_number.includes("+") ? formData.phone_number : "+" + formData.phone_number) : "";
        const payload = [{
            customer_name: formData.name || "",
            customer_phone: customerPhone,
            stage_id: 1,
            branch_id: selectedTourData?.branch_id || "",
            customer_email: customerEmail,
            org_id: selectedTourData?.organization_id || "",
            created_by: 0,
            source_id: "marketplace",
            lead_priority: "medium",
            remarks: notes || ""
        }];
        console.log("payload========", payload)
        // return false
        return createDmcLead(payload)
            .then((response) => {
                console.log("DMC lead created", response);
                const leadData = Array.isArray(response) ? response[0]?.data : response?.data;
                const leadId = leadData?.id;
                if (leadId) {
                    const phoneNumber = formData.phone_number ? formData.phone_number.replace(/\D/g, '').slice(-10) : "";
                    const searchData = props.groupTourPackageSearchData || {};
                    const noteLocation = searchData.starting_from?.label || searchData.starting_from?.value || selectedTourData.DestinationFrom?.destination_name || "";
                    const noteStartDate = selectedTourData?.is_fixed_date
                        ? (selectedTourData?.start_date ? moment(selectedTourData.start_date).format('YYYY-MM-DD') : null)
                        : (startDate && moment(startDate).isValid() ? moment(startDate).format('YYYY-MM-DD') : null);
                    const noteEndDate = selectedTourData?.is_fixed_date
                        ? (selectedTourData?.end_date ? moment(selectedTourData.end_date).format('YYYY-MM-DD') : null)
                        : (endDate && moment(endDate).isValid() ? moment(endDate).format('YYYY-MM-DD') : null);
                    const notePayload = [{
                        customer_phone_number: phoneNumber,
                        content: "Lead created successfully",
                        content_json: {
                            tour_id: selectedTourData.tour_id || selectedTourData.id,
                            location: noteLocation,
                            start_date: noteStartDate,
                            end_date: noteEndDate,
                            adults: numAdults,
                            children: numChildren,
                            branch_id: selectedTourData?.branch_id || "",
                            org_id: selectedTourData?.organization_id || ""
                        },
                        lead_id: leadId,
                        branch_id: selectedTourData?.branch_id || "",
                        org_id: selectedTourData?.organization_id || ""
                    }];
                    return createDmcNote(notePayload)
                        .then((noteResponse) => {
                            console.log("DMC note created", noteResponse);
                            Utility.toastNotifications("Thank you for your enquiry. Your request has been submitted successfully. Our team will review it and share a quote with you shortly.", "Success", "success");
                            setBookingCancellationModalFlag(false);
                            history.push(`/${localStorage.getItem('i18nextLng') || 'en'}/home`);
                        })
                        .catch((noteError) => {
                            console.error("DMC note error", noteError);
                        });
                }
            })
            .catch((error) => {
                console.error("DMC lead error", error);
            });
    };

    //booking confirmation modal confirm button click functionality
    const confirmbookingConfirmButton = (type = "") => {
        const { loaderStateTrue, loaderStateFalse } = props;
        loaderStateTrue();
        submitDmcLead().finally(() => {
            loaderStateFalse();
        });
    }

    const cancellationModalHide = () => {
        setBookingCancellationModalFlag(false);
    }

    //Confirm This Booking pop up modal cancel button fn
    const confirmbookingCancellationCancleButton = () => {
        setBookingCancellationModalFlag(false);
    }


    return (
        <div className='dynamicGroupContainerBox'>
            <div className='dynamicGroupContainer bookingModalContentBox'>
                <div className='bookingModalContentBoxInner'>
                    <div className='rowCover'>
                        <div className='datePanel room-book-bx'>
                            <div className='rowCoverInner'>
                                <div className='row positionPanel multiRow borderBottom'>
                                    <div className='col-md-3 paddingR0'>
                                        <div className={selectedTourData?.is_fixed_date == true ? 'datePickerBOX disabled' : 'datePickerBOX'}>
                                            <label>Start Date <span>*</span></label>
                                            <ErrorBoundary title="CommonDateTimePicker Error">
                                                <CommonDateTimePicker
                                                    selected={startDate}
                                                    onChange={(e) => handelChangeDate(e, 'start_date')}
                                                    showTimeSelect={false}
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select date"
                                                    minDate={new Date()}
                                                    maxDate={new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate())}
                                                    popperPlacement="bottom-end"
                                                    positionFixed
                                                    popperClassName="dateTime-picker-quatations-multiple"
                                                    onKeyDown={(e) => e.preventDefault()}
                                                    disabled={selectedTourData?.is_fixed_date}
                                                />
                                            </ErrorBoundary>
                                        </div>
                                    </div>

                                    <div className='col-md-3'>
                                        <div className={selectedTourData?.is_fixed_date == true ? 'datePickerBOX disabled' : 'datePickerBOX disabled'}>
                                            <label>End Date</label>
                                            <ErrorBoundary title="CommonDateTimePicker Error">
                                                <CommonDateTimePicker
                                                    selected={endDate}
                                                    minDate={startDate}
                                                    maxDate={new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate())}
                                                    onChange={(e) => handelChangeDate(e, 'end_date')}
                                                    showTimeSelect={false}
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select date"
                                                    // disabled={selectedTourData?.is_fixed_date}
                                                    disabled={true}
                                                    popperPlacement="bottom-end"
                                                    positionFixed
                                                    popperClassName="dateTime-picker-quatations-multiple"
                                                    onKeyDown={(e) => e.preventDefault()}
                                                />
                                            </ErrorBoundary>
                                        </div>
                                    </div>

                                    <div className='col-md-6'>
                                        <div className='row'>
                                            <div className='roomBookfieldset'>
                                                <ul className='roomBookfieldsetul'>
                                                    <li className='adult-row'>
                                                        <div className='labelInputField'>
                                                            <div className='left-row-box left-row-label'>Adults</div>
                                                            <div className='right-row-box'>
                                                                <div className="input-group">
                                                                    <div className="input-group-prepend">
                                                                        <button className="btn btn-outline-primary btn-left" type="button" onClick={decNumAdults}>-</button>
                                                                    </div>
                                                                    <input type="text" className="form-control" value={numAdults} disabled style={{ backgroundColor: "#EEF0F5", cursor: "no-drop" }} />
                                                                    <div className="input-group-prepend">
                                                                        <button className="btn btn-outline-primary btn-right" type="button" onClick={incNumAdults}>+</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>

                                                    <li className='childrenContainerBox child-row'>
                                                        <div className='labelInputField'>
                                                            <div className='left-row-box left-row-label'>Children</div>
                                                            <div className='right-row-box'>
                                                                <div className="input-group">
                                                                    <div className="input-group-prepend">
                                                                        <button className="btn btn-outline-primary btn-left" type="button" onClick={decNumChildren}>-</button>
                                                                    </div>
                                                                    <input type="text" className="form-control" value={numChildren} disabled style={{ backgroundColor: "#EEF0F5", cursor: "no-drop" }} />
                                                                    <div className="input-group-prepend">
                                                                        <button className="btn btn-outline-primary btn-right" type="button" onClick={incNumChildren}>+</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    {props.isGuestFlag &&
                        <div className='row'>
                            <div className="col-md-12">
                                <div className="tour-package-summary">
                                    <h4 className="summary-title">Selected Package Summary</h4>
                                    <div className="summary-row">
                                        <span className="summary-label">Package</span>
                                        <span className="summary-value">{selectedTourData?.tour_name || selectedTourData?.template_name || 'Tour Package'}</span>
                                    </div>
                                    <div className="summary-row">
                                        <span className="summary-label">Adults ({numAdults})</span>
                                        <span className="summary-value">
                                            {Utility.getCurrencySymbol(currencyName)}
                                            {Number(selectedTourData?.price_for_adult || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                                            <small> x {numAdults} = {Utility.getCurrencySymbol(currencyName)}{Number((selectedTourData?.price_for_adult || 0) * numAdults).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</small>
                                        </span>
                                    </div>
                                    {numChildren > 0 && (
                                        <div className="summary-row">
                                            <span className="summary-label">Children ({numChildren})</span>
                                            <span className="summary-value">
                                                {Utility.getCurrencySymbol(currencyName)}
                                                {Number(selectedTourData?.price_for_children || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                                                <small> x {numChildren} = {Utility.getCurrencySymbol(currencyName)}{Number((selectedTourData?.price_for_children || 0) * numChildren).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</small>
                                            </span>
                                        </div>
                                    )}
                                    <div className="summary-row total-row">
                                        <span className="summary-label">Total</span>
                                        <span className="summary-value total-value">
                                            {Utility.getCurrencySymbol(currencyName)}
                                            {Number(((selectedTourData?.price_for_adult || 0) * numAdults) + ((selectedTourData?.price_for_children || 0) * numChildren)).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {props.isGuestFlag &&
                        <div className='row'>
                            <div className="col-md-12">
                                <ErrorBoundary title="CustomInput Error">
                                    <CustomInput
                                        parentClassName="input_field_inner input_field_inner_note"
                                        labelName="Notes"
                                        errorLabel={notesError}
                                        name="notes"
                                        type="textarea"
                                        value={notes}
                                        labelPresent={true}
                                        requiredStar={false}
                                        onChange={(e) => handelChangeCustomerFn(e, 'notes')}
                                    />
                                </ErrorBoundary>
                            </div>
                        </div>

                    }
                    {props.isGuestFlag && <h3 className='modal-title-label'>Customer details</h3>}
                    {props.isGuestFlag && <div className='customerSecBox'>
                        {props.isGuestFlag && <div className='paymentCustomerHotelPart relativeRow' id='page-bottom'>
                            <div className='row'>
                                <div className="col-md-3">
                                    <ErrorBoundary title="CustomInput Error">
                                        <CustomInput
                                            parentClassName="input_field_inner"
                                            labelName="First name"
                                            errorLabel={formDataError.name}
                                            name="branch_name"
                                            type="text"
                                            value={formData.name}
                                            labelPresent={true}
                                            onChange={(e) => handelChangeCustomerFn(e, 'name')}
                                        />
                                    </ErrorBoundary>
                                </div>
                                <div className="col-md-3">
                                    <ErrorBoundary title="CustomInput Error">
                                        <CustomInput
                                            parentClassName="input_field_inner"
                                            labelName="Last name"
                                            errorLabel={formDataError.last_name}
                                            name="last_name"
                                            type="text"
                                            value={formData.last_name}
                                            labelPresent={true}
                                            onChange={(e) => handelChangeCustomerFn(e, 'last_name')}
                                        />
                                    </ErrorBoundary>
                                </div>
                                <div className="col-md-3">
                                    <ErrorBoundary title="CustomInput Error">
                                        <PhoneNumberWithCountryCode
                                            title="Phone Number"
                                            country={selectedCountryCode}
                                            value={formData.phone_number}
                                            onChange={(e, country) => handelChangeCustomerFn(e, 'phone_number', country)}
                                            error={formDataError.phone_number}
                                            labelShow={true}
                                            requirStart={true}
                                            disableDropdown={false}
                                        />
                                    </ErrorBoundary>
                                </div>
                                {emailUi()}
                                <div ref={emailInputRef}></div>
                            </div>
                        </div>}
                    </div>}
                </div>
            </div>
            <div className='col-md-12 previewBtnContainer'>
                <button className="btn btn-success previewSubBtn" onClick={paymentAndBookingFn}>Submit</button>
                <button className="btn btn-success previewCancelBtn" onClick={skipFn}>Cancel</button>
            </div>

            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={bookingCancellationModalFlag}
                    onHide={cancellationModalHide}
                    className="modalcustomize confirmationalertmodal"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title="Enquiry confirmation"
                    footer={false}
                    body={
                        <>
                            <ErrorBoundary title="ConfirmationAlert Error">
                                <ConfirmationAlert
                                    BodyFirstContent="Would you like to proceed with this enquiry?"
                                    BodyThirdContent=""
                                    confirmationButtonContent="Confirm"
                                    cancelButtonContent="Cancel"
                                    deleteConfirmButton={confirmbookingConfirmButton}
                                    deleteCancleButton={confirmbookingCancellationCancleButton}
                                    deleteIconVissable={false}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

        </div>
    );
}

const mapStateToProps = (globalState) => ({
    userCredentials: globalState.LoginReducer.userCredentials,
    tourSearchDataFromReducer: globalState.mainReducerData.tourSearchData,
    groupTourPackageSearchData: globalState.mainReducerData.groupTourPackageSearchData

});

export default connect(mapStateToProps, {
    handleActiveLink,
    loaderStateTrue,
    loaderStateFalse,
    userSearchData, selectChooseBranch, priceDistributionRequestData, priceDistributionResponseData, setToken, setUserCredentials
})(withNamespaces()(TourBooking));